import './Tag.scss';

import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import classNames from 'classnames';
import TagsCRUDActions from '@mm/state/actions/TagsCRUDActions';
import { StoreState } from '@mm/state/store-interfaces';

import TagModel from '@mm/state/model/TagModel';
import clearSvg from './clear.svg';

type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;

type OuterProps = {
  item: TagModel;
  contactId: number;
  fbPageId: number;
  onChange?: (newTags: TagModel[]) => void;
  removable?: boolean;
  otnTags?: boolean;
};

type TagProps = OuterProps & PropsFromDispatch;

const TagPure = ({
  item,
  onDelete,
  fbPageId,
  contactId,
  onChange,
  removable = true,
  otnTags,
}: TagProps) => {
  const onTagRemove = async () => {
    const tags = await onDelete(
      item.name || '',
      item.kind || undefined,
      fbPageId,
      contactId,
    );
    onChange && tags && onChange(tags);
  };

  const className = classNames('contact-tags__tag', {
    'contact-tags__tag-otn': otnTags,
  });

  return (
    <div className={className}>
      <div>
        {`${item.name}${item.kind === 'otn' && !otnTags ? ' (OTN)' : ''}`}
      </div>
      {removable && (
        <div className="contact-tags__tag-remove" onClick={onTagRemove}>
          <img src={clearSvg} />
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  onDelete: (
    name: string,
    kind: 'otn' | 'regular' | 'service' | undefined,
    fbPageId: number,
    contactId: number,
  ) => dispatch(TagsCRUDActions.unassign(name, kind, fbPageId, contactId)),
});

export const Tag = connect<{}, PropsFromDispatch, OuterProps>(
  null,
  mapDispatchToProps,
)(TagPure);
